<template>
    <div class="StepReminder">
        {{ $f.tc('remind') }}
        <v-text-field
            outlined
            dense
            hide-details
            :label="this.$f.tc('minute')"
            class="my-3"
            v-model="reminderMinute"
            @focusout="saveReminder"
        ></v-text-field>
        {{ $f.tc('sendMessageAfterNoInteraction') }}
    </div>
</template>

<script>
import { ScenarioService } from '@/services/bot.service'

export default {
    name: 'StepReminder',
    data () {
        return {
            reminderMinute: 0
        }
    },
    mounted () {
        for (let appConfig of this.$store.state.scenario.appConfigList) {
            if (appConfig.config_key === 'dm_expired_session_time_out') {
                this.reminderMinute = Number(appConfig.config_value)
                break
            }
        }
    },
    methods: {
        saveReminder () {
            ScenarioService.updateReminder(this.$route.params.botCode, this.reminderMinute)
        }
    }
}
</script>

<style scoped lang="scss">
.StepReminder {
    padding: 10px;
}
</style>
